export default __webpack_public_path__ + "static/media/PlasmaSystemImg.96cea805.jpg";